import { createFileRoute } from "@tanstack/react-router";
import AdminSetsPage from "@/pages/admin/sets";

export const Route = createFileRoute("/app/admin/sets")({
  component: AdminSetsPage,
});
